import TrackingLink from '../link/tracking-link'

export default props => {
  return <a {...props} class='main-menu-link'>{props.children}</a>
}

export const CategoryLink = props => {
  return <TrackingLink {...props} class='main-menu-link main-menu-link--category'>
    <span>{props.children}</span>
    <span>{props.topicsCount}</span>
  </TrackingLink>
}
